// extracted by mini-css-extract-plugin
export default {"completeWindow":"CompleteWindow_completeWindow__oRwxL","crown":"CompleteWindow_crown__s8bxV","pulse-blue":"CompleteWindow_pulse-blue__vNEwP"};